export default __webpack_public_path__ + "static/ghost_feisty-f11a1a9592752efc1f9bf823258fda31.svg";